import {Alpha3CountryCode} from '../utils/countryCodes';

export type Country = {
  name: string;
  dialCode: string;
  countryCode: Alpha3CountryCode;
};
